import mixins from 'vue-typed-mixins';

/**
 * Mixin allows to create `bem` entities named from the parent component as elements
 * and add a modifier for the block in the component.
 */
export const bemClasses = mixins().extend({
	data() {
		return {
			bem: {
				mix: '' as string,
				modifier: '' as string
			}
		};
	},
	mounted() {
		if (this.$attrs.bem)
			Object.assign(this.bem, { ...this.$attrs.bem as {} });
	},
	methods: {
		set(cls: string): string {
			const isElement = /__/.test(cls);
			const separator = this.bem.mix.match(/_/g)?.length === 2 ? '-' : '__';
			const mix = `${cls} ${this.bem.mix}${separator}${cls.replace(/__/, '-')}`;
			const modifier = `${cls} ${cls}--${this.bem.modifier}`;

			if (!isElement) {
				if (this.bem.mix && this.bem.modifier)
					return `${mix} ${modifier}`;

				if (this.bem.mix)
					return mix;

				if (this.bem.modifier)
					return modifier;
			}

			if (isElement && this.bem.mix)
				return mix;

			return cls;
		}
	},
});
